import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetAllMailsLockedParams } from 'src/app/shared/models/mails/mails-lock';
import { MailLockEntryDTO, MailsLockDTO } from '../interfaces/mails/mails-lock-dto.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MailsLockUnlockService {
  private url: string;

  constructor(private http: HttpClient) {
    const config = environment;
    this.url = config.apiICourrierBaseUrl;
  }

  /* @params mode : Available values : Read, Write */
  postLockUnlock(courrierID: number, mode: string, version: number): Observable<void> {
    return this.http.put<void>(`${this.url}/Mails/${courrierID}/Lock?mode=${mode}&version=${version}`, {});
  }

  /* @params mode : Available values : Read, Write */
  unLock(mode: string, data: { courrierIds: number[] }): Observable<void> {
    return this.http.put<void>(`${this.url}/Mails/UnlockMails?mode=${mode}`, data);
  }

  getAllLockedMails(data: GetAllMailsLockedParams): Observable<MailsLockDTO> {
    let params = new HttpParams();
    Object.keys(data).forEach((key) => {
      if (data[key] !== null) {
        params = params.set(key, data[key]);
      }
    });
    return this.http.get<MailsLockDTO>(`${this.url}/Mails/Locks?${params}`);
  }

  getLockInfo(courrierID: number): Observable<MailLockEntryDTO[]> {
    return this.http.get<MailLockEntryDTO[]>(`${this.url}/Mails/${courrierID}/Locks`);
  }
}
